import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_atomic_crm_dark.svg";
import lightModeLogo from "./logos/logo_atomic_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "EUR";

export const defaultTitle = "Atelier Augmenté";

export const defaultCompanySectors = [
  {
    "value": "Organisme de formation",
    "label": "Organisme de formation"
  },
  {
    "value": "Immobilier",
    "label": "Immobilier"
  },
  {
    "value": "Transport / logistique",
    "label": "Transport / logistique"
  },
  {
    "value": "Commerce en ligne",
    "label": "Commerce en ligne"
  },
  {
    "value": "Artisanat / bâtiment",
    "label": "Artisanat / bâtiment"
  },
  {
    "value": "Architecture / bureau d'études",
    "label": "Architecture / bureau d'études"
  },
  {
    "value": "Conseil / services aux entreprises",
    "label": "Conseil / services aux entreprises"
  },
  {
    "value": "Recrutement / intérim",
    "label": "Recrutement / intérim"
  },
  {
    "value": "Assurance / courtage",
    "label": "Assurance / courtage"
  },
  {
    "value": "Propreté / nettoyage",
    "label": "Propreté / nettoyage"
  },
  {
    "value": "Services à la personne",
    "label": "Services à la personne"
  },
  {
    "value": "Santé / vétérinaire / médico-social",
    "label": "Santé / vétérinaire / médico-social"
  },
  {
    "value": "Négoce / distribution",
    "label": "Négoce / distribution"
  },
  {
    "value": "Expertise comptable",
    "label": "Expertise comptable"
  },
  {
    "value": "Pompes funèbres",
    "label": "Pompes funèbres"
  },
  {
    "value": "Garage / automobile",
    "label": "Garage / automobile"
  },
  {
    "value": "Industrie / production",
    "label": "Industrie / production"
  },
  {
    "value": "Commerce de détail (boutique)",
    "label": "Commerce de détail (boutique)"
  },
  {
    "value": "Restauration",
    "label": "Restauration"
  },
  {
    "value": "Hôtellerie / gîtes / chambres d'hôtes",
    "label": "Hôtellerie / gîtes / chambres d'hôtes"
  },
  {
    "value": "Agriculture / viticulture",
    "label": "Agriculture / viticulture"
  },
  {
    "value": "Association",
    "label": "Association"
  },
  {
    "value": "Profession juridique",
    "label": "Profession juridique"
  },
  {
    "value": "Logiciel / start-up / services numériques",
    "label": "Logiciel / start-up / services numériques"
  },
  {
    "value": "Agence (communication, web, événementiel)",
    "label": "Agence (communication, web, événementiel)"
  },
  {
    "value": "Beauté / bien-être / coiffure",
    "label": "Beauté / bien-être / coiffure"
  },
  {
    "value": "Import-export / commerce international",
    "label": "Import-export / commerce international"
  },
  {
    "value": "Collectivité",
    "label": "Collectivité"
  },
  {
    "value": "Autre secteur",
    "label": "Autre secteur"
  }
];

export const defaultDealStages = [
  {
    "value": "opportunity",
    "label": "Piste"
  },
  {
    "value": "appel-fait",
    "label": "Appel fait"
  },
  {
    "value": "proposal-sent",
    "label": "Proposition envoyée"
  },
  {
    "value": "in-negociation",
    "label": "En négociation"
  },
  {
    "value": "won",
    "label": "Gagnée"
  },
  {
    "value": "paid",
    "label": "Payée"
  },
  {
    "value": "lost",
    "label": "Perdue"
  },
  {
    "value": "delayed",
    "label": "Reportée"
  }
];

export const defaultDealPipelineStatuses = ["won", "paid"];

export const defaultDealCategories = [
  {
    "value": "automatisation",
    "label": "Automatisation"
  },
  {
    "value": "plusieurs-automatisations",
    "label": "Plusieurs automatisations"
  },
  {
    "value": "site-service-en-ligne",
    "label": "Site ou service en ligne"
  },
  {
    "value": "maintenance",
    "label": "Maintenance (TMA)"
  },
  {
    "value": "autre",
    "label": "Autre"
  }
];

export const defaultNoteStatuses = [
  {
    "value": "cold",
    "label": "Froid",
    "color": "#7dbde8"
  },
  {
    "value": "warm",
    "label": "Tiède",
    "color": "#e8cb7d"
  },
  {
    "value": "hot",
    "label": "Chaud",
    "color": "#e88b7d"
  },
  {
    "value": "in-contract",
    "label": "Client",
    "color": "#a4e87d"
  }
];

export const defaultTaskTypes = [
  {
    "value": "none",
    "label": "Aucun"
  },
  {
    "value": "call",
    "label": "Appel"
  },
  {
    "value": "email",
    "label": "Email"
  },
  {
    "value": "follow-up",
    "label": "Relance"
  },
  {
    "value": "demo",
    "label": "Démonstration"
  },
  {
    "value": "meeting",
    "label": "Rendez-vous"
  },
  {
    "value": "thank-you",
    "label": "Remerciement"
  }
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
